import { KeycloakEnv } from '../../api/environment';

export enum KeycloakResponseMode {
  Query = 'query',
  Hash = 'fragment',
}

export interface WisaUserProviderProps {
  /**
   * The route to which is redirected, when the user logs out
   */
  logoutRoute: string;
  children: React.ReactNode;

  /**
   * Called, when the user provider is not yet initialized
   */
  renderLoading(): JSX.Element;

  getKeycloakInitOptions(): Promise<KeycloakEnv | null>;

  /**
   * The response mode used by keycloak
   */
  responseMode?: KeycloakResponseMode;
}
